type ChatwootConversationLike = Readonly<Record<string, unknown>> & {
  readonly assignee_id?: unknown;
  readonly meta?: unknown;
};

export const WESSAL_COMPOSER_ASSIGNEE_REQUIRED =
  'WESSAL_COMPOSER_ASSIGNEE_REQUIRED';
export const WESSAL_COMPOSER_FOREIGN_ASSIGNEE =
  'WESSAL_COMPOSER_FOREIGN_ASSIGNEE';

function assigneeId(value: unknown): string | null {
  if (typeof value !== 'string' && typeof value !== 'number') return null;
  const normalized = String(value);
  return /^[1-9]\d*$/u.test(normalized) ? normalized : null;
}

function projectedAssigneeValues(
  conversation: ChatwootConversationLike
): unknown[] {
  const values: unknown[] = [];
  if (Object.prototype.hasOwnProperty.call(conversation, 'assignee_id')) {
    values.push(conversation.assignee_id);
  }
  const meta =
    conversation.meta &&
    typeof conversation.meta === 'object' &&
    !Array.isArray(conversation.meta)
      ? (conversation.meta as Readonly<Record<string, unknown>>)
      : {};
  const assignee =
    meta.assignee &&
    typeof meta.assignee === 'object' &&
    !Array.isArray(meta.assignee)
      ? (meta.assignee as Readonly<Record<string, unknown>>)
      : null;
  if (assignee && Object.prototype.hasOwnProperty.call(assignee, 'id')) {
    values.push(assignee.id);
  } else if (Object.prototype.hasOwnProperty.call(meta, 'assignee')) {
    values.push(null);
  }
  return values;
}

export function isExactWessalComposerAssignee(
  conversation: ChatwootConversationLike,
  workspaceUserId: string | number
): boolean {
  const expected = assigneeId(workspaceUserId);
  if (!expected) return false;
  const projectedIds = projectedAssigneeValues(conversation).map(assigneeId);
  return (
    projectedIds.length > 0 && projectedIds.every(value => value === expected)
  );
}

export function hasProjectedWessalAssignee(
  conversation: ChatwootConversationLike
): boolean {
  return projectedAssigneeValues(conversation).some(
    value => assigneeId(value) !== null
  );
}
